import { render, staticRenderFns } from "./SupplierVoucher.vue?vue&type=template&id=3754dc1a&scoped=true"
import script from "./SupplierVoucher.vue?vue&type=script&lang=js"
export * from "./SupplierVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754dc1a",
  null
  
)

export default component.exports